import dayjs from 'dayjs';
import { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Button, Box, Typography, Chip } from '@mui/material';

const shortcutsItems = [
  {
    label: 'Esta Semana',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('week'), today.endOf('week')];
    },
  },
  {
    label: 'Ultima Semana',
    getValue: () => {
      const today = dayjs();
      const prevWeek = today.subtract(7, 'day');
      return [prevWeek.startOf('week'), prevWeek.endOf('week')];
    },
  },
  {
    label: 'Ultimos 7 dias',
    getValue: () => {
      const today = dayjs();
      return [today.subtract(7, 'day'), today];
    },
  },
  {
    label: 'En el mes',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('month'), today.endOf('month')];
    },
  },
  {
    label: 'Reiniciar',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('day'), today.endOf('day')];
    }
  },
];

const DateInterval = ({ onChange, startDate: from, endDate: to }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedShortcut, setSelectedShortcut] = useState(null);

  const handleShortcut = (getValue, label) => {
    const [start, end] = getValue();
    setStartDate(start?.startOf('day'));
    setEndDate(end?.startOf('day'));
    setSelectedShortcut(label);
    onChange && onChange(start?.startOf('day'), end?.startOf('day'))
  };

  useEffect(() => {
    if (from) {
      setStartDate(dayjs(from).startOf('day'));
    }
    if (to) {
      setEndDate(dayjs(to).startOf('day'));
    }
  }, [from, to]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box display="flex" gap={2}>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue.startOf('day')); // Ajuste a medianoche
              if (endDate && newValue && newValue.isAfter(endDate)) {
                setEndDate(null);
              }
              onChange && onChange(newValue, endDate)
            }}
            maxDate={endDate} // Limitar la fecha de inicio para no ser posterior a la fecha de fin
            format="DD/MM/YYYY" // Formato personalizado
          />
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue.startOf('day'))
              onChange && onChange(startDate, newValue)
            }}
            minDate={startDate} // Limitar la fecha de fin para no ser anterior a la fecha de inicio
            format="DD/MM/YYYY" // Formato personalizado
          />
        </Box>

        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
          <Box display="flex" gap={1} flexWrap="wrap" justifyContent="center">
            {shortcutsItems.map((item, index) => (
              // <Button key={index} variant="outlined" onClick={() => handleShortcut(item.getValue)}>
              //   {item.label}
              // </Button>
              <Chip
                color={selectedShortcut === item.label ? 'primary' : 'default'}
                key={index}
                variant="outlined"
                onClick={() => handleShortcut(item.getValue, item.label)}
                label={item.label}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default DateInterval;
